import React, {
  Fragment,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import { Editor } from 'react-draft-wysiwyg';
import {
  FaBuilding,
  FaCalendarAlt,
  FaClipboard,
  FaQuestionCircle,
  FaStickyNote,
} from 'react-icons/fa';
import { useHistory, useLocation, useParams } from 'react-router-dom';

import {
  Badge,
  Box,
  Button,
  Checkbox,
  Flex,
  Menu,
  MenuButton,
  MenuItem,
  MenuItemOption,
  MenuList,
  Text,
  Tooltip,
  useClipboard,
  useDisclosure,
  useToast,
} from '@chakra-ui/react';
import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import { format, parseISO, setWeek } from 'date-fns';
import { ContentState, EditorState } from 'draft-js';
import queryString from 'query-string';

import Highlights from '~/shared/components/Highlights';
import InputChakra from '~/shared/components/InputChakra';
import SelectChakra from '~/shared/components/InputChakra/SelectChakra';
import LoadingAbsolute from '~/shared/components/LoadingAbsolute';
import ModalChakra from '~/shared/components/Modal/ChakraUI';
import SectionHeader from '~/shared/components/SectionHeader';
import Table, { THeadProps } from '~/shared/components/Table';
import api from '~/shared/services/api';

import { Attendance } from '../../@types/activity';

interface ReasonDevolution {
  id: number;
  nome: string;
  descricao?: string;
}

interface Users {
  id: number;
  name: string;
  email: string;
  avatar: string;
  avatar_old_name: string;
  cover: string;
  created_at: string;
  cover_old_name: string;
  responsibility: string;
  responsibility_id: number;
  department_id: number;
  departmnet_name: string;
  is_active: number;
}

interface Responsibilities {
  id: number;
  name: string;
}

interface Params {
  planningId?: string;
}

interface QueryParams {
  dem_id?: number;
  act_id?: number;
  aten_id?: number;
}

interface Observation {
  activity_name: string;
  activity_order: number;
}

/* interface Inputs {
  list: InitialData
} */

interface InitialData {
  activity_id?: number;
  duration: string;
  employee_id: number;
  fatal_date: string;
  fatal_hours: string;
  id?: number;
  minimun_start: string;
  planning_employee: string;
  status_id: number;
}

interface PlanningsActivities {
  id?: number;
  activity_id?: number;
  planning_id: number;
  demand_id: number;
  status_id: number;
  employee_id: number;
  duration: string;
  start_date: string;
  start_time: string;
  end_date: string;
  end_time: string;
  minimun_start: string;
  fatal_date: string;
  fatal_hour: string;
  name: string;
  order: number;
  description: string;
  status_name: string;
  status_color: string;
  employee: string;
  observation: string;
  responsibilities: Responsibilities[];
  checked?: boolean;
  sub: number;
}

interface AtttendaceData {
  attendance_id: number;
  demand_id: number;
  competence: string;
  attendance_description: string;
  created_at: string;
  demand: string;
  status: string;
  status_id: number;
  status_color: string;
  employee: string;
  company_id: number;
  fantasy_name: string;
  company: string;
}

interface EmployeePlan {
  id: number;
  name: string;
  email: string;
  avatar: string;
  avatar_old_name: string;
  cover: string;
  created_at: string;
  cover_old_name: string;
  responsibility: string;
  responsibility_id: number;
  department_id: number;
  department_name: string;
  is_active: number;
}

interface Devolution {
  activities: PlanningsActivities[];
  attendance_data: AtttendaceData;
  users: Users[];
  employee_plan: EmployeePlan;
  reason_devolution: ReasonDevolution[];
}

const ActivityReturn: React.FC = () => {
  const { planningId } = useParams<Params>();
  const location = useLocation();

  const addToast = useToast();

  const queryParams = useMemo<QueryParams>(() => {
    return queryString.parse(location.search);
  }, [location.search]);

  const formRef = useRef<FormHandles>(null);

  const observationRef = useRef<FormHandles>(null);

  const [loadingAttendance, setLoadingAttendance] = useState(true);
  const [loading, setLoading] = useState(true);
  const [LoadingSubmit, setLoadingSubmit] = useState(true);

  const [employees, setEmployees] = useState<Users[]>([]);

  // const [employeePlan, setEmployeePlan] = useState<EmployeePlan>();
  // const [attendanceData, setAttendanceData] = useState<AtttendaceData>();
  // const [plannings, setPlannings] = useState<PlanningsActivities[]>([]);

  const [observation, setObservation] = useState<Observation>();

  const [editorState, setEditorState] = useState<EditorState>(
    EditorState.createEmpty(),
  );

  const [reasonsDevolution, setReasonsDevolution] = useState<
    ReasonDevolution[]
  >([]);

  const [attendance, setAttendance] = useState<Attendance>();

  const [
    activitySelected,
    setActivitySelected,
  ] = useState<PlanningsActivities>();
  const [activitiesSuccessors, setActivitiesSuccessors] = useState<
    PlanningsActivities[]
  >([]);

  const {
    isOpen: isOpenObs,
    onOpen: onOpenObs,
    onClose: onCloseObs,
  } = useDisclosure();

  const tableTitles = useMemo((): THeadProps[] => {
    return [
      {
        title: '',
      },
      {
        title: '',
      },
      {
        title: '',
      },
      {
        title: 'Responsável',
      },
      {
        title: 'Início mínimo',
      },
      {
        title: 'Data Fatal',
      },
      {
        title: 'Hora Fatal',
      },
      {
        title: 'Observação',
      },
    ];
  }, []);

  const handleDevolutionProps = useCallback(() => {
    api
      .get<Devolution>(`plannings/devolution/${planningId}`)

      .then((response) => {
        setLoading(true);
        const {
          activities,
          /*  attendance_data,
          employee_plan, */
          reason_devolution,
          users,
        } = response.data;

        // setPlannings(activities);

        setActivitySelected(
          activities.find((act) => act.planning_id.toString() === planningId),
        );

        setActivitiesSuccessors(
          activities.filter(
            (successors) => successors.planning_id.toString() !== planningId,
          ),
        );

        // setInitialData();

        setEmployees(users);
        setReasonsDevolution(reason_devolution);
        // setEmployeePlan(employee_plan);
        // setAttendanceData(attendance_data);
      })

      .finally(() => setLoading(false));
  }, [planningId]);

  const attendanceInfo = useCallback(() => {
    setLoadingAttendance(true);

    api
      .get<Attendance>(`/attendances/${queryParams.aten_id}`)
      .then((response) => {
        const { data } = response;

        setAttendance({
          ...data,
          created_at: format(
            parseISO(data.created_at),
            "dd/MM/yyyy 'às' HH'h'mm'min'",
          ),
        });
      })
      .finally(() => setLoadingAttendance(false));
  }, [queryParams]);

  const headerObservation = useCallback(
    (name, order) => {
      setObservation({ activity_name: name, activity_order: order });

      onOpenObs();
    },
    [onOpenObs],
  );

  const handleSubmit = useCallback(
    async (dataActivities) => {
      setLoadingSubmit(true);

      try {
        api.post(`plannings/devolution`, dataActivities);

        addToast({
          position: 'top-right',
          isClosable: true,
          status: 'success',
          title: 'Atividade devolvida com sucesso!',
          description: 'Use sua nova senha para fazer login',
        });

        setLoadingSubmit(false);
      } catch (err) {
        setLoadingSubmit(false);

        addToast({
          position: 'top-right',
          isClosable: true,
          status: 'error',
          title: 'Erro ao devolver a atividade',
          description:
            'Não foi possível registrar a devolução, da(s) atividade(s)',
        });
      }
    },
    [addToast],
  );

  useEffect(() => {
    attendanceInfo();
    handleDevolutionProps();

    /* const content = htmlToDraft(data.pop);
    setEditorState(
      EditorState.createWithContent(
        ContentState.createFromBlockArray(content.contentBlocks),
      ),
    ); */
  }, [attendanceInfo, handleDevolutionProps]);

  return (
    <>
      <Box pos="relative">
        <SectionHeader
          title="Devolução de Atividades"
          pagename="Devolução de Atividades"
          goBackPage
        />

        <Flex justifyContent="space-between" alignItems="center">
          <Highlights
            data={[
              {
                icon: FaClipboard,
                label: 'Demanda:',
                text: !loadingAttendance
                  ? attendance?.demand.name
                  : 'Carregando...',
              },
            ]}
          />
          <Highlights
            data={[
              {
                icon: FaBuilding,
                label: 'Empresa:',
                text: !loadingAttendance
                  ? attendance?.company_client.name
                  : 'Carregando...',
              },
            ]}
          />
          <Highlights
            data={[
              {
                icon: FaCalendarAlt,
                label: 'Data da Solicitação:',
                text: !loadingAttendance
                  ? attendance?.created_at
                  : 'Carregando...',
              },
            ]}
          />
        </Flex>

        {loading ? (
          <LoadingAbsolute z_index={1111} min_height={500} />
        ) : (
          <>
            <Form
              onSubmit={handleSubmit}
              ref={formRef}
              initialData={{
                duration: activitySelected?.duration,
                responsible: activitySelected?.employee_id,
                minimum_start: activitySelected?.minimun_start,
                fatal_date: activitySelected?.fatal_date,
                fatal_hour: activitySelected?.fatal_hour,
                observation: activitySelected?.observation,
                // sub: typeReturnRef.current,
                successors: activitiesSuccessors,
              }}
            >
              <Table theadData={tableTitles} loading={loading}>
                <Box as="tr">
                  <Box as="td" colSpan={3}>
                    <SelectChakra
                      name="main[motives]"
                      options={
                        reasonsDevolution?.length
                          ? reasonsDevolution?.map((motives) => {
                              return {
                                label: motives.nome,
                                value: motives.id,
                              };
                            })
                          : []
                      }
                      placeholder="Selecione o motivo da devolução"
                      disabled={loading}
                      required
                    />
                  </Box>

                  <Box as="td" justifyContent="center">
                    <SelectChakra
                      width="350px"
                      name="main[general_responsible]"
                      options={
                        employees?.length
                          ? employees?.map((emp) => {
                              return {
                                label: `${emp.name} - [${emp.responsibility}]`,
                                value: emp.id,
                              };
                            })
                          : []
                      }
                      placeholder="Escolha um responsável geral..."
                      disabled={loading}
                      required
                    />
                  </Box>
                  <Box as="td" justifyContent="center">
                    <InputChakra
                      name="main[all_minimun_start]"
                      type="datetime-local"
                      width="220px"
                    />
                  </Box>
                  <Box as="td" justifyContent="center">
                    <InputChakra
                      name="main[all_fatal_date]"
                      type="date"
                      width="200px"
                    />
                  </Box>
                  <Box as="td" justifyContent="center">
                    <InputChakra name="main[all_fatal_hour]" type="time" />
                  </Box>
                </Box>
                <Box as="tr">
                  <Box as="td" />
                  <Box as="td">
                    <Text lineHeight={1.4} color="#718096">
                      <b>ATIVIDADE SELECIONADA</b>
                    </Text>
                  </Box>

                  <Box as="td">
                    <Text lineHeight={1.4} color="#718096">
                      <b>DURAÇÃO</b>
                    </Text>
                  </Box>
                </Box>

                <Box as="tr">
                  <Box as="td">
                    {' '}
                    <InputChakra
                      type="hidden"
                      name="main[check_selected_actv]"
                      value={activitySelected?.checked ? 1 : 0}
                    />
                    <Checkbox
                      name="main[check_selected_actv]"
                      defaultIsChecked
                    />
                  </Box>

                  <Box as="td">
                    <Text>{`${activitySelected?.order} - ${activitySelected?.name}`}</Text>

                    <Flex marginTop="5px" alignItems="center">
                      <Box marginRight="15px">
                        <Badge colorScheme={activitySelected?.status_color}>
                          {activitySelected?.status_name}
                        </Badge>
                      </Box>

                      {activitySelected?.status_id === 14 && (
                        <Box>
                          <Tooltip
                            aria-label="Atividades não iniciadas não constarão como devolvidas, serão apenas replanejadas para que fique após a predecessora devolvida"
                            label="Atividades não iniciadas não constarão como devolvidas, serão apenas replanejadas para que fique após a predecessora devolvida"
                            placement="top"
                          >
                            <Box>
                              <FaQuestionCircle />
                            </Box>
                          </Tooltip>
                        </Box>
                      )}
                    </Flex>
                  </Box>

                  <Box as="td" justifyContent="center">
                    <InputChakra name="main[duration]" type="time" />
                  </Box>

                  <Box as="td" justifyContent="center">
                    <SelectChakra
                      width="350px"
                      name="main[responsible]"
                      options={
                        employees?.length
                          ? employees?.map((emp) => {
                              return {
                                label: `${emp.name} - [${emp.responsibility}]`,
                                value: emp.id,
                              };
                            })
                          : []
                      }
                      placeholder="Selecione o funcionário"
                    />
                  </Box>

                  <Box as="td" justifyContent="center">
                    <InputChakra
                      name="main[minimum_start]"
                      type="datetime-local"
                      width="220px"
                    />
                  </Box>

                  <Box as="td" justifyContent="center">
                    <InputChakra
                      name="main[fatal_date]"
                      type="date"
                      width="200px"
                    />
                  </Box>

                  <Box as="td" justifyContent="center">
                    <InputChakra name="main[fatal_hour]" type="time" />
                  </Box>

                  <Flex as="td" justifyContent="center">
                    <Button
                      name="main[observation]"
                      onClick={() =>
                        headerObservation(
                          activitySelected?.name,
                          activitySelected?.order,
                        )
                      }
                    >
                      <FaStickyNote />
                    </Button>
                  </Flex>
                </Box>

                {!!activitiesSuccessors.length && !loading && (
                  <>
                    <Box as="tr">
                      <Box as="td" />
                      <Box as="td">
                        <Text lineHeight={1.4} color="#718096">
                          <b>ATIVIDADES SUCESSORAS</b>
                        </Text>
                      </Box>
                    </Box>
                    {activitiesSuccessors.map((activities, idx) => {
                      return (
                        <>
                          <Box as="tr" key={activities.activity_id}>
                            <Box as="td">
                              <InputChakra
                                name={`successors[${idx}][check_atv]`}
                                type="hidden"
                                value={activities.checked ? 1 : 0}
                              />
                              <Checkbox
                                name={`successors[${idx}][check_atv]`}
                                defaultIsChecked
                                onChange={() =>
                                  activitiesSuccessors.map((act_check) => {
                                    return act_check.planning_id ===
                                      activities.planning_id
                                      ? {
                                          ...act_check,
                                          checked: !act_check.checked,
                                        }
                                      : act_check;
                                  })
                                }
                              />{' '}
                              <InputChakra
                                type="hidden"
                                name={`successors[${idx}][planning_id]`}
                              />
                            </Box>
                            <Box as="td">
                              <Text>{`${activities.order} - ${activities.name}`}</Text>

                              <Flex
                                marginTop="5px"
                                alignItems="center"
                                /* marginBottom="5px" */
                              >
                                <Box marginRight="15px">
                                  <Badge colorScheme={activities.status_color}>
                                    {activities.status_name}
                                  </Badge>
                                </Box>

                                {activities.status_id === 14 && (
                                  <Box>
                                    <Tooltip
                                      aria-label="Atividades não iniciadas não constarão como devolvidas, serão apenas replanejadas para que fique após a predecessora devolvida"
                                      label="Atividades não iniciadas não constarão como devolvidas, serão apenas replanejadas para que fique após a predecessora devolvida"
                                      placement="top"
                                    >
                                      <Box>
                                        <FaQuestionCircle />
                                      </Box>
                                    </Tooltip>
                                  </Box>
                                )}
                              </Flex>
                            </Box>

                            <Box as="td" justifyContent="center">
                              <InputChakra
                                name={`successors[${idx}][duration]`}
                                type="time"
                              />
                            </Box>

                            <Box as="td" justifyContent="center">
                              {activities.employee_id && (
                                <SelectChakra
                                  name={`successors[${idx}][employee_id]`}
                                  width="350px"
                                  options={
                                    employees?.length
                                      ? employees?.map((emp) => {
                                          return {
                                            label: `${emp.name} - [${emp.responsibility}]`,
                                            value: emp.id,
                                          };
                                        })
                                      : []
                                  }
                                  placeholder="Selecione o funcionário"
                                />
                              )}
                            </Box>

                            <Box as="td" justifyContent="center">
                              <InputChakra
                                name={`successors[${idx}][minimum_start]`}
                                type="datetime-local"
                                width="220px"
                              />
                            </Box>

                            <Box as="td" justifyContent="center">
                              <InputChakra
                                name={`successors[${idx}][fatal_date]`}
                                type="date"
                                width="200px"
                              />
                            </Box>

                            <Box as="td" justifyContent="center">
                              <InputChakra
                                name={`successors[${idx}][fatal_hour]`}
                                type="time"
                              />
                            </Box>

                            <Flex as="td" justifyContent="center">
                              <Button
                                name={`successors[${idx}][observation]`}
                                onClick={() =>
                                  headerObservation(
                                    activities.name,
                                    activities.order,
                                  )
                                }
                              >
                                <FaStickyNote />
                              </Button>
                            </Flex>
                          </Box>
                        </>
                      );
                    })}
                  </>
                )}
              </Table>

              <InputChakra type="hidden" name="sub" />
              <Flex justifyContent="end" marginTop="20px">
                <Menu>
                  <MenuButton as={Button}>Devolver</MenuButton>
                  <MenuList>
                    <MenuItemOption>
                      <Button
                        type="button"
                        onClick={() => {
                          // typeReturnRef.current = 1;
                          formRef.current?.setFieldValue('sub', 1);
                          formRef.current?.submitForm();
                        }}
                        variant="ghost"
                      >
                        Entrega Imediata
                      </Button>
                    </MenuItemOption>
                    <MenuItemOption>
                      <Button
                        type="button"
                        onClick={() => {
                          formRef.current?.setFieldValue('sub', 2);
                          formRef.current?.submitForm();
                        }}
                        variant="ghost"
                      >
                        Inserir na Fila
                      </Button>
                    </MenuItemOption>
                  </MenuList>
                </Menu>
              </Flex>
            </Form>
          </>
        )}
      </Box>
      <ModalChakra
        title={`Observação | ${observation?.activity_order} - ${observation?.activity_name}`}
        onClose={() => {
          onCloseObs();
        }}
        isOpen={isOpenObs}
        titleButtonCancel="Cancelar"
        onSubmit={() => observationRef.current?.submitForm()}
        isLoading={loading}
        titleButtonConfirm="Salvar"
      >
        <Editor
          editorState={editorState}
          placeholder="Escreva aqui a observação"
          toolbarClassName="toolbarClassName"
          wrapperClassName="wrapperClassName"
          editorClassName="editorClassName"
          onEditorStateChange={(editor) => setEditorState(editor)}
          editorStyle={{ padding: '1rem' }}
        />
      </ModalChakra>
    </>
  );
};

export default ActivityReturn;
